import React, {Component} from "react"
import PropTypes from "prop-types"

class FlashMessage extends Component {
  onClick() {
    this.props.deleteFlashMessage(this.props.message.id)
  }

  render() {
    const {text} = this.props.message

    return (
      <div>
        <button onClick={this.onClick.bind(this)}>
          <span>&times;</span>
        </button>
        {text}
      </div>
    )
  }
}

FlashMessage.propTypes = {
  message: PropTypes.object.isRequired,
  deleteFlashMessage: PropTypes.func.isRequired
}

export default FlashMessage



// WEBPACK FOOTER //
// ./src/components/flash/FlashMessage.js